module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby","meta":[{"name":"description","content":"Sample"},{"name":"keywords","content":"sample, something"},{"name":"theme-color","content":"rebeccapurple"}],"version":"1.9.256"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 156
// module chunks = 60335399758886 114276838955818